// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}

.price {
  font-size: 14px;
  font-weight: bold;
  color: var(--color-black);
}

ion-label {
  font-size: 14px;
}
@media (min-width: 991px) {
  ion-label {
    padding-right: 5px;
  }
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  --background: #F6F1EF;
  background: #F6F1EF;
  margin: 10px 10px;
  --inner-padding-end: 2px;
  padding: 0px 10px;
  border-radius: 26px;
  border: 1px solid transparent;
  transition: opacity 0.3s ease;
}
ion-item.selected {
  border: 1px solid var(--color-black);
}
ion-item.item-disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
ion-item.item-disabled ion-label {
  color: #999;
}

.item-img {
  width: 50px;
  padding: 7px;
}

ion-checkbox::part(container) {
  background-size: contain;
  border-radius: 50%;
  border-color: var(--border-color-checked);
}

ion-checkbox.checkbox-checked::part(container) {
  border-radius: 50%;
}

ion-checkbox {
  --checkbox-background: #F6F1EF;
  --border-color-checked: var(--color-black);
  --checkbox-background-checked: transparent;
  height: 20px;
  width: 20px;
}

.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  color: #1A1A18 !important;
  font-family: AppFont, sans-serif !important;
  display: flex;
  letter-spacing: -0.5px;
}

.mehr-articles {
  width: -moz-fit-content;
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}

.hidden {
  visibility: hidden;
}

.qty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
}
.qty__btn {
  width: 20px;
  height: 20px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  line-height: 16px;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--color-black);
}
.qty .qty-number.zero {
  color: transparent;
}

ion-toggle {
  --handle-background-checked: var(--primary-btn);
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AADF;;AAIA;EACE,eAAA;AADF;ACdE;EDcF;IAGI,kBAAA;EACF;AACF;;AAEA;EACE,+BAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;AAEF;AAAE;EACE,oCAAA;AAEJ;AACE;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;AACJ;AACI;EACE,WAAA;AACN;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,wBAAA;EACA,kBAAA;EACA,yCAAA;AADF;;AAGA;EAGE,kBAAA;AAFF;;AAIA;EACE,8BAAA;EACA,0CAAA;EACA,0CAAA;EACA,YAAA;EACE,WAAA;AADJ;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AADF;AAGE;EACE,yBAAA;EAEA,2CAAA;EACA,aAAA;EACA,sBAAA;AAFJ;;AAMA;EACE,uBAAA;EAAA,kBAAA;AAHF;AAIE;EACE,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFJ;AAGI;EACE,kBAAA;AADN;AAGI;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AADN;AAEM;EACE,cAAA;AAAR;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAII;EACE,4BAAA;AAFN;AAKI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EAEA,YAAA;EACA,iBAAA;AAJN;AAQE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AANJ;AAQI;EACE,kBAAA;AANN;;AAYA;EAGG,+CAAA;AAXH","sourcesContent":["@import '../../../theme/mixins';\n\nion-radio-group {\n  width: 100%;\n  border-radius: 0px;\n  padding: 5px;\n  display: block;\n}\n\n.price {\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--color-black);\n}\n\nion-label {\n  font-size: 14px;\n  @include desktop {\n    padding-right: 5px;\n  }\n}\n\nion-icon {\n  color: var(--ion-color-primary);\n  height: 20px;\n  width: 20px;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item{\n  --background: #F6F1EF;\n  background: #F6F1EF;\n  margin: 10px 10px;\n  --inner-padding-end: 2px;\n  padding: 0px 10px;\n  border-radius: 26px;\n  border: 1px solid transparent;\n  transition: opacity 0.3s ease;\n\n  &.selected {\n    border: 1px solid var(--color-black);\n  }\n\n  &.item-disabled {\n    opacity: 0.4;\n    pointer-events: none;\n    cursor: not-allowed;\n\n    ion-label {\n      color: #999;\n    }\n  }\n}\n\n.item-img {\n  width: 50px;\n  padding: 7px;\n}\n\nion-checkbox::part(container) {\n  background-size: contain;\n  border-radius: 50%;\n  border-color: var(--border-color-checked)\n}\nion-checkbox.checkbox-checked::part(container) {\n  // background: var(--ion-color-primary);\n  // border-color: transparent;\n  border-radius: 50%;\n}\nion-checkbox {\n  --checkbox-background: #F6F1EF;\n  --border-color-checked: var(--color-black);\n  --checkbox-background-checked: transparent;\n  height: 20px;\n    width: 20px;\n}\n\n.text_wrap {\n  text-align: left;\n  text-wrap: wrap;\n  white-space: normal;\n  word-break: break-word;\n  \n  span {\n    color: #1A1A18 !important;\n    \n    font-family: AppFont, sans-serif  !important;\n    display: flex;\n    letter-spacing: -0.5px ;\n\n  }\n}\n.mehr-articles {\n  width: fit-content;\n  div {\n    background: white;\n    border: 1px solid black;\n    padding: 5px 10px;\n    border-radius: 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h3 {\n      margin-right: 20px;\n    }\n    ion-icon {\n      color: black;\n      margin-left: 15px;\n      rotate: 0deg;\n      transition: rotate 0.7s ;\n      &.rotate {\n        rotate: 180deg;\n      }\n    }\n  }\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.qty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  &__btn {\n    width: 20px;\n    height: 20px;\n    margin: 0 !important;\n    box-shadow: none;\n    --box-shadow: none;\n\n    button {\n      box-shadow: unset !important;\n    }\n\n    span {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n\n      color: white;\n      line-height: 16px\n    }\n  }\n\n  .qty-number {\n    margin: 0 4px;\n    text-align: center;\n    min-width: 15px;\n    color: var(--color-black);\n\n    &.zero {\n      color: transparent\n    }\n  }\n}\n\n\nion-toggle {\n  // border: 1px solid var(--color-black);\n  // border-radius: 26px;\n   --handle-background-checked: var(--primary-btn);\n  // --track-background: transparent;\n  // --track-background-checked: transparent;\n\n  // --handle-background: #ebdfda;\n\n  // --handle-width: 39px;\n  // --handle-height: 25px;\n  // --handle-max-height: auto;\n  // --handle-spacing: 0px;\n  // --handle-border-radius: 26px;\n  // --handle-box-shadow: none;\n  // .toggle-inner {\n  //   border: 1px solid black;\n  // }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
